export function isPromise(obj) {
  return obj && typeof obj.then === 'function';
}


//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/react-router/es/PromiseUtils.js
// module id = 4IrO
// module chunks = 1